<template>
  <footer class="footer">
    <div class="container">
      <div class="brand-logo">
        <img :src="logo" class="logo-site" />
      </div>
      <div class="row mt-5">
        <div class="col-lg-3 col-md-6 col-sm-12 footer-column">
          <h5>{{ $t("footer.about") }}</h5>
          <ul v-if="aproposArticles.length">
            <li v-for="article in aproposArticles" :key="article.id">
              <RouterLink :to="`/page/${article.id}-${article.slug}`">{{ article.title }}</RouterLink>
            </li>
          </ul>
          <ul>
            <li>
              <a href="#">{{ $t("footer.accessibility") }}</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 footer-column">
          <h5>{{ $t("footer.help_support") }}</h5>
          <ul>
            <li>
              <RouterLink to="/faq">{{ $t("footer.faq") }}</RouterLink>
            </li>
            <li>
              <a href="#">{{ $t("footer.guide") }}</a>
            </li>
            <li>
              <RouterLink to="/contact">{{ $t("footer.contact") }}</RouterLink>
            </li>
            <li v-if="isClient">
               <a :href="isProfessional ? lienpro : lienconso" target="_blank" >{{ $t("footer.terms") }}</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 footer-column">
          <h5>{{ $t("footer.products_services") }}</h5>
          <ul>
            <li>
              <router-link to="/dashboard/products">{{ $t("footer.catalog") }}</router-link>
            </li>
           
          </ul>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 footer-column">
          <h5>{{ $t("footer.stay_connected") }}</h5>
          <div class="d-flex align-items-center  justify-content-center-mobile gap-2">
            <p class="mb-0">{{ $t("footer.follow_us") }}</p>

            <div class="social-media d-flex gap-2">
              <a href="https://www.facebook.com/certivet72" target="_blank"><img :src="facebook" /></a>
              <a href="https://www.instagram.com/certivet_" target="_blank"><img :src="instagrame" /> </a>
              <a href="https://www.youtube.com/@C_Veto" target="_blank"><img :src="youtube" /></a>
              <a href="https://www.linkedin.com/company/laboratoire-certivet/mycompany/" target="_blank"
                ><img :src="linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5 last-row">
        <hr />
        <div class="b1 col-lg-8 col-md-6 col-sm-12 mt-2">
          <p class="my-0 slogant">{{ $t("footer.copyright") }}</p>
        </div>
        <div class="b2 col-lg-4 col-md-6 col-sm-12 mt-2">
          <p class="my-0 slogant">{{ $t("footer.developed_by") }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import facebook from "../assets/facbook.png";
  import instagrame from "../assets/instagrame.png";
  import linkedin from "../assets/linkedin.png";
  import youtube from "../assets/youtube.png";
  import logo from "../assets/images/2_LOGO - BLANC.png";
  import { useArticlesStore } from "@/stores/articlesStore";
  import { useAuthStore } from "@/stores/authStore";  
import { useRegisterStore } from '@/stores/register';

  export default {
    name: "AppFooter",
    data() {
      return {
        facebook,
        instagrame,
        linkedin,
        youtube,
        logo,
        articlesStore: null,
        authStore: null,
        registerStore: null,
        lienpro: process.env.VUE_APP_TERMS_LINK_PRO,
        lienconso: process.env.VUE_APP_TERMS_LINK_CONS
      };
    },
    computed: {
      aproposArticles() {
        if (!this.articlesStore?.articles) return [];
        return this.articlesStore.articles.filter(
          (article) => article.category?.name === "footer-Apropos"
        );
      },

      isProfessional() {
      return this.registerStore.clientInfo?.professionnel || false;
    },
     isClient() {
        return this.registerStore.user?.role === "client";
      },
    },    
    methods: {
      async getFooterData() {
        await this.articlesStore.fetchArticles();
      },
    }, 
    async created() {
      this.articlesStore = useArticlesStore();
      this.authStore = useAuthStore();
      this.registerStore = useRegisterStore();

      await this.getFooterData();
    },   
  };

  
</script>

<style scoped>
  .footer {
    background-color: #1e347d;
    color: white;
    padding: 70px 20px 20px;
    text-align: left;
  }
  .footer .text-footer {
    color: #1e347d;
    font-weight: bold;
    text-transform: uppercase;
  }
  .footer .slogant {
    font-size: 12px;
    opacity: 0.5;
  }

  .footer-column h3 {
    margin-bottom: 10px;
  }

  .footer-column ul {
    list-style: none;
    padding: 0;
  }

  .footer-column ul li {
    margin-bottom: 8px;
  }

  .footer-column ul li a {
    color: white;
    text-decoration: none;
  }

  .footer-column ul li a:hover {
    text-decoration: underline;
  }

  .last-row {
    .b1 {
      width: 80%;
    }
    .b2 {
      width: 20%;
    }
  }

  @media (max-width: 768px) {
    .footer {
      flex-direction: column;
      text-align: center;
    }
  }
</style>
